import type React from 'react';
import { cn } from '../../../lib/utils.ts';

type InfoBlockProps = {
    children?: React.ReactNode | React.ReactNode[];
};

export const InfoBlock: InfoBlockComponent = ({ children }) => {
    return <div className={cn('flex flex-col gap-3')}>{children}</div>;
};

type BlockProps = {
    children?: React.ReactNode;
    title: string | React.ReactNode;
    className?: string;
};

const Block: React.FC<BlockProps> = ({ children, title, className = '' }) => {
    return (
        <div className="overflow-hidden rounded-lg border border-neutral-100">
            <div className="flex flex-row items-center justify-between bg-neutral-25 px-3 py-2 text-sm leading-5 font-semibold">
                {title}
            </div>
            <div
                className={cn(
                    'flex w-full flex-col justify-between gap-3 bg-white px-3 py-2 sm:flex-row sm:gap-8',
                    className,
                )}
            >
                {children}
            </div>
        </div>
    );
};

type ItemProps = {
    children?: React.ReactNode;
};

const Item: React.FC<ItemProps> = ({ children }) => {
    return <div className="flex flex-col flex-1 gap-1">{children}</div>;
};

type TitleProps = {
    children?: React.ReactNode;
};

const Title: React.FC<TitleProps> = ({ children }) => {
    return <div className="text-sm font-medium text-neutral-500">{children}</div>;
};

type BodyProps = {
    children?: React.ReactNode;
    className?: string;
    isBottom?: boolean;
};

const Body: React.FC<BodyProps> = ({ children, isBottom = false, className }) => {
    return (
        <div
            className={cn(
                'text-sm font-normal',
                {
                    'mt-auto': isBottom,
                },
                className,
            )}
        >
            {children}
        </div>
    );
};

type InfoBlockComponent = {
    Block: React.FC<BlockProps>;
    Item: React.FC<ItemProps>;
    Title: React.FC<TitleProps>;
    Body: React.FC<BodyProps>;
} & React.FC<InfoBlockProps>;

InfoBlock.Block = Block;
InfoBlock.Item = Item;
InfoBlock.Title = Title;
InfoBlock.Body = Body;
